export const INTEGRATIONS = {
    DISABLED: 'DISABLED',
    GEOCOMPLY_DESKTOP: 'GEOCOMPLY_DESKTOP',
    GEOCOMPLY_OOBEE: 'GEOCOMPLY_OOBEE',
    GEOCOMPLY_NATIVE: 'GEOCOMPLY_NATIVE',
    GEOCOMPLY_SOLUS: 'GEOCOMPLY_SOLUS'
};
